export default "__VITE_ASSET__kYFtnGZy__"